import React from 'react';
import PropTypes from 'prop-types';
import QualifiedPlayerCard from './QualifiedPlayerCard';

export default function QualifiedPlayerCardItem({ index, ...rest }) {
    function getBgIndex() {
        return ((index) % 3) + 1;
    }

    return (
        <QualifiedPlayerCard {...rest} bg={getBgIndex(index)}/>
    );
}

QualifiedPlayerCardItem.propTypes = {
    index: PropTypes.number.isRequired
};
